namespace RioERP.Web.Enums {
    export enum EnquiryType {
        lead = 1,
        technicalSupport = 2,
        dispatch = 3,
        other = 4
    }
    Serenity.Decorators.registerEnumType(EnquiryType, 'RioERP.Web.Enums.EnquiryType');
}
